/**
 * Sound-effect library — real one-shot SFX sourced from popular Korean
 * shorts/TV compilation packs. Files live in `apps/editor/public/sfx/*.mp3`
 * (served at `/sfx/<file>`); the ECS export renderer resolves the same files
 * via its `getSfxPath` resolver. This replaces the old procedural-synth specs.
 *
 * This metadata (code/label/description/file/durationSec) is the single source
 * of truth — imported by the editor preview, the export renderer, and the agent.
 * Generated from apps/editor/public/sfx/sfx.json.
 */
export interface SfxSpec {
  /** Stable id used in EDL sfx items and the agent tool. */
  code: string;
  /** Korean display name (original clip title). */
  label: string;
  /** When to use it (Korean) — surfaced to the agent + search UI. */
  description: string;
  /** Asset filename under /sfx/. */
  file: string;
  durationSec: number;
  /**
   * 순간에 얹는 «원샷»인가. 5초를 넘거나 BGM 성격이면 false —
   * 자동 배치에서 제외한다(사람이 직접 고르는 것은 막지 않는다).
   */
  oneShot: boolean;
}

export const SFX_LIBRARY: Record<string, SfxSpec> = {
  'absurd-laugh': {
    code: 'absurd-laugh',
    label: '어이없는웃음',
    description: '어이없어 터지는 웃음',
    file: 'absurd-laugh.mp3',
    durationSec: 7.0,
    oneShot: false,
  },
  'absurd-laugh-2': {
    code: 'absurd-laugh-2',
    label: '어이없는웃음2',
    description: '어이없는 웃음(변형)',
    file: 'absurd-laugh-2.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  ambulance: {
    code: 'ambulance',
    label: '엠뷸란스',
    description: '응급·큰일 난 상황',
    file: 'ambulance.mp3',
    durationSec: 5.0,
    oneShot: true,
  },
  ang: {
    code: 'ang',
    label: '앙',
    description: "'앙' 애교·깜찍 리액션",
    file: 'ang.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  'baby-cry': {
    code: 'baby-cry',
    label: '아기울음',
    description: '아기 울음·징징댐',
    file: 'baby-cry.mp3',
    durationSec: 4.0,
    oneShot: true,
  },
  beep: {
    code: 'beep',
    label: '삐삑',
    description: '오답/정답 판정, 검열 삐 처리',
    file: 'beep.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  brake: {
    code: 'brake',
    label: '브레이크',
    description: '급정거·멈칫',
    file: 'brake.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  'burp-2': {
    code: 'burp-2',
    label: '트림2',
    description: '트림',
    file: 'burp-2.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  'burp-3': {
    code: 'burp-3',
    label: '트림3',
    description: '트림(변형)',
    file: 'burp-3.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  'car-crash': {
    code: 'car-crash',
    label: '교통사고',
    description: '충돌·대형 사고',
    file: 'car-crash.mp3',
    durationSec: 5.0,
    oneShot: true,
  },
  'cash-register': {
    code: 'cash-register',
    label: '철컥띵캐셔',
    description: '계산대 철컥띵',
    file: 'cash-register.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  'censor-beep': {
    code: 'censor-beep',
    label: '삐',
    description: '검열 삐 처리',
    file: 'censor-beep.mp3',
    durationSec: 4.0,
    oneShot: true,
  },
  'come-here': {
    code: 'come-here',
    label: '드루와',
    description: "'드루와' 도발·오라",
    file: 'come-here.mp3',
    durationSec: 4.0,
    oneShot: true,
  },
  'come-here-2': {
    code: 'come-here-2',
    label: '드루와2',
    description: "'드루와' 도발(변형)",
    file: 'come-here-2.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  'defeat-cry': {
    code: 'defeat-cry',
    label: '루우패배',
    description: "크아! 패배 절규 '루우~'",
    file: 'defeat-cry.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  'despair-bgm': {
    code: 'despair-bgm',
    label: '좌절BGM',
    description: '좌절 브금',
    file: 'despair-bgm.mp3',
    durationSec: 8.0,
    oneShot: false,
  },
  'dramatic-boom': {
    code: 'dramatic-boom',
    label: '두둥액션',
    description: '두둥! 극적인 등장·반전',
    file: 'dramatic-boom.mp3',
    durationSec: 6.0,
    oneShot: false,
  },
  'evil-laugh': {
    code: 'evil-laugh',
    label: '사악한웃음',
    description: '사악한 웃음·음모',
    file: 'evil-laugh.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  exclamation: {
    code: 'exclamation',
    label: '느낌표',
    description: '깨달음·느낌표 강조',
    file: 'exclamation.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  'exclamation-2': {
    code: 'exclamation-2',
    label: '느낌표',
    description: '깨달음·느낌표 강조(변형)',
    file: 'exclamation-2.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  explosion: {
    code: 'explosion',
    label: '폭발음',
    description: '폭발·터지는 상황',
    file: 'explosion.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  falling: {
    code: 'falling',
    label: '떨어질때',
    description: '추락·떨어질 때',
    file: 'falling.mp3',
    durationSec: 7.0,
    oneShot: false,
  },
  fanfare: {
    code: 'fanfare',
    label: '빠빠빠빠암',
    description: '팡파레·승리 등장',
    file: 'fanfare.mp3',
    durationSec: 4.0,
    oneShot: true,
  },
  'fart-1': {
    code: 'fart-1',
    label: '방귀뿡1',
    description: '방귀',
    file: 'fart-1.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  'fart-2': {
    code: 'fart-2',
    label: '방귀뿡2',
    description: '방귀(변형)',
    file: 'fart-2.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  'fast-forward': {
    code: 'fast-forward',
    label: '빨리감기',
    description: '빨리감기·구간 생략',
    file: 'fast-forward.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  'full-throttle': {
    code: 'full-throttle',
    label: '풀악셀',
    description: '풀악셀 가속',
    file: 'full-throttle.mp3',
    durationSec: 15.0,
    oneShot: false,
  },
  gasp: {
    code: 'gasp',
    label: '뜨헉',
    description: '놀람·충격 리액션',
    file: 'gasp.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  'glass-break': {
    code: 'glass-break',
    label: '쨍그랑',
    description: '유리 깨짐·사고 순간',
    file: 'glass-break.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  goodbye: {
    code: 'goodbye',
    label: '안녕히계세요',
    description: '작별 인사',
    file: 'goodbye.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  'goodbye-everyone': {
    code: 'goodbye-everyone',
    label: '안녕히계세요여러분',
    description: '떠나감·작별 밈',
    file: 'goodbye-everyone.mp3',
    durationSec: 4.0,
    oneShot: true,
  },
  gunshot: {
    code: 'gunshot',
    label: '총소리',
    description: '총소리·총격',
    file: 'gunshot.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  headshot: {
    code: 'headshot',
    label: '뚝배기',
    description: '머리 강타(뚝배기 깨짐)',
    file: 'headshot.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  heartbeat: {
    code: 'heartbeat',
    label: '심장소리',
    description: '긴장·두근거림',
    file: 'heartbeat.mp3',
    durationSec: 10.0,
    oneShot: false,
  },
  hello: {
    code: 'hello',
    label: '안녕하세요',
    description: '인사·등장',
    file: 'hello.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  hit: {
    code: 'hit',
    label: '명중',
    description: '정확히 맞췄을 때',
    file: 'hit.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  huh: {
    code: 'huh',
    label: '어엉',
    description: '얼빠진·멍한 리액션',
    file: 'huh.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  'hydra-spit': {
    code: 'hydra-spit',
    label: '히드라침',
    description: '스타 히드라 침 뱉기',
    file: 'hydra-spit.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  liar: {
    code: 'liar',
    label: '입만벌리면그짓말',
    description: "'입만 벌리면 거짓말' 밈",
    file: 'liar.mp3',
    durationSec: 5.0,
    oneShot: true,
  },
  'long-scream': {
    code: 'long-scream',
    label: '아아아악',
    description: '길게 지르는 비명',
    file: 'long-scream.mp3',
    durationSec: 3.5,
    oneShot: true,
  },
  'man-scream': {
    code: 'man-scream',
    label: '남자비명',
    description: '남자 비명',
    file: 'man-scream.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  'marine-death-1': {
    code: 'marine-death-1',
    label: '마린죽음1',
    description: '스타 마린 죽음',
    file: 'marine-death-1.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  'marine-death-2': {
    code: 'marine-death-2',
    label: '마린죽음2',
    description: '스타 마린 죽음(변형)',
    file: 'marine-death-2.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  'mario-coin': {
    code: 'mario-coin',
    label: '마리오동전',
    description: '득점·아이템 획득',
    file: 'mario-coin.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  'medic-death': {
    code: 'medic-death',
    label: '메딕죽음',
    description: '스타 메딕 죽음',
    file: 'medic-death.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  'my-eyes': {
    code: 'my-eyes',
    label: '내눈',
    description: '눈뽕/충격적인 장면',
    file: 'my-eyes.mp3',
    durationSec: 4.0,
    oneShot: true,
  },
  'no-god-please': {
    code: 'no-god-please',
    label: '노갓플리즈',
    description: "절망 'No God Please No' 밈",
    file: 'no-god-please.mp3',
    durationSec: 7.0,
    oneShot: false,
  },
  'no-no': {
    code: 'no-no',
    label: '노노',
    description: '부정·거부',
    file: 'no-no.mp3',
    durationSec: 4.0,
    oneShot: true,
  },
  'no-no-no': {
    code: 'no-no-no',
    label: '노노노',
    description: '강한 부정·거부',
    file: 'no-no-no.mp3',
    durationSec: 6.0,
    oneShot: false,
  },
  'oh-no': {
    code: 'oh-no',
    label: '아안돼',
    description: "'아 안돼' 절망",
    file: 'oh-no.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  'one-shot-left': {
    code: 'one-shot-left',
    label: '아직한발남았다',
    description: "'아직 한 발 남았다' 밈",
    file: 'one-shot-left.mp3',
    durationSec: 4.0,
    oneShot: true,
  },
  peekaboo: {
    code: 'peekaboo',
    label: '까꿍',
    description: '갑자기 등장하거나 반전되는 순간',
    file: 'peekaboo.mp3',
    durationSec: 4.0,
    oneShot: true,
  },
  'pistol-shot': {
    code: 'pistol-shot',
    label: '권총한발',
    description: '권총 한 발',
    file: 'pistol-shot.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  pop: {
    code: 'pop',
    label: '뽀옥',
    description: '뿅 하고 사라지거나 등장',
    file: 'pop.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  punch: {
    code: 'punch',
    label: '펀치',
    description: '때리는 타격음',
    file: 'punch.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  'question-mark': {
    code: 'question-mark',
    label: '물음표',
    description: '의문·갸우뚱',
    file: 'question-mark.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  'rapid-hits': {
    code: 'rapid-hits',
    label: '연타',
    description: '연타 타격',
    file: 'rapid-hits.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  'reverse-beep': {
    code: 'reverse-beep',
    label: '후진벨',
    description: '후진 경고음 삐빅',
    file: 'reverse-beep.mp3',
    durationSec: 6.0,
    oneShot: false,
  },
  rewind: {
    code: 'rewind',
    label: '되감기',
    description: '되감기·다시보기 연출',
    file: 'rewind.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  'room-of-truth': {
    code: 'room-of-truth',
    label: '진실의방으로',
    description: "'진실의 방으로' 밈",
    file: 'room-of-truth.mp3',
    durationSec: 4.0,
    oneShot: true,
  },
  'run-away': {
    code: 'run-away',
    label: '도망',
    description: '도망가는 장면 강조',
    file: 'run-away.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  'running-steps': {
    code: 'running-steps',
    label: '도망가는소리',
    description: '후다닥 도망가는 발소리',
    file: 'running-steps.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  'sad-bgm': {
    code: 'sad-bgm',
    label: '슬픈BGM',
    description: '슬픈 브금',
    file: 'sad-bgm.mp3',
    durationSec: 10.0,
    oneShot: false,
  },
  'sad-music': {
    code: 'sad-music',
    label: '슬픈음악',
    description: '슬프고 우울한 상황',
    file: 'sad-music.mp3',
    durationSec: 7.0,
    oneShot: false,
  },
  scream: {
    code: 'scream',
    label: '아아악',
    description: '비명·경악',
    file: 'scream.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  shotgun: {
    code: 'shotgun',
    label: '샷건',
    description: '강한 타격·한 방',
    file: 'shotgun.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  'siege-mode': {
    code: 'siege-mode',
    label: '시즈모드',
    description: '스타 시즈모드 전환',
    file: 'siege-mode.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  'sneaky-escape': {
    code: 'sneaky-escape',
    label: '얄미운줄행랑',
    description: '얄밉게 줄행랑',
    file: 'sneaky-escape.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  spin: {
    code: 'spin',
    label: '스핀',
    description: '회전·화면 전환',
    file: 'spin.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  stimpack: {
    code: 'stimpack',
    label: '스팀팩',
    description: '스타크래프트 스팀팩(스피드 업)',
    file: 'stimpack.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  surprise: {
    code: 'surprise',
    label: '서프라이즈',
    description: '짜잔·서프라이즈',
    file: 'surprise.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  'surprise-bgm': {
    code: 'surprise-bgm',
    label: '놀라는배경음',
    description: '놀람 배경음',
    file: 'surprise-bgm.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  'ta-da': {
    code: 'ta-da',
    label: '쨔라',
    description: "'쨔라~' 짜잔 등장",
    file: 'ta-da.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  'ta-dan': {
    code: 'ta-dan',
    label: '따딴',
    description: "'따딴' 등장·반전",
    file: 'ta-dan.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  'tension-horror': {
    code: 'tension-horror',
    label: '긴장공포',
    description: '긴장·공포 분위기 조성',
    file: 'tension-horror.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  ting: {
    code: 'ting',
    label: '띠링',
    description: '알림·아이디어 반짝',
    file: 'ting.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  'too-much': {
    code: 'too-much',
    label: '이건너무한거아니냐고',
    description: '억울·과하다는 항의',
    file: 'too-much.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  'tv-static': {
    code: 'tv-static',
    label: 'TV지지직',
    description: 'TV 지지직·노이즈',
    file: 'tv-static.mp3',
    durationSec: 5.0,
    oneShot: true,
  },
  'urgent-bgm': {
    code: 'urgent-bgm',
    label: '다급한브금',
    description: '다급·급박한 상황 배경음',
    file: 'urgent-bgm.mp3',
    durationSec: 13.0,
    oneShot: false,
  },
  'what-nonsense': {
    code: 'what-nonsense',
    label: '먼개소리야',
    description: '어이없는 헛소리 리액션',
    file: 'what-nonsense.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  'what-the': {
    code: 'what-the',
    label: '왓더퍽',
    description: "'What the...' 황당",
    file: 'what-the.mp3',
    durationSec: 4.0,
    oneShot: true,
  },
  'wrong-taunt': {
    code: 'wrong-taunt',
    label: '못맞췄지롱',
    description: '약올림·틀렸지롱',
    file: 'wrong-taunt.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  'x-files': {
    code: 'x-files',
    label: 'X파일',
    description: '미스터리·의문의 상황',
    file: 'x-files.mp3',
    durationSec: 5.0,
    oneShot: true,
  },
  yes: {
    code: 'yes',
    label: '예',
    description: '긍정·수긍 밈',
    file: 'yes.mp3',
    durationSec: 3.0,
    oneShot: true,
  },
  'yes-sir': {
    code: 'yes-sir',
    label: '옛썰',
    description: "'옛썰!' 힘찬 대답",
    file: 'yes-sir.mp3',
    durationSec: 2.0,
    oneShot: true,
  },
  'you-shall-not-pass': {
    code: 'you-shall-not-pass',
    label: '넌못지나간다',
    description: '막아섬·저지',
    file: 'you-shall-not-pass.mp3',
    durationSec: 5.0,
    oneShot: true,
  },
};

export const DEFAULT_SFX_IDS = Object.keys(SFX_LIBRARY);

/** Highlight sentiment → suggested sfx id (for the agent / auto-suggestions). */
export const SENTIMENT_SFX: Record<string, string> = {
  excited: 'fanfare',
  positive: 'ting',
  negative: 'oh-no',
  mixed: 'huh',
};

export function sfxSpec(sfxId: string): SfxSpec | null {
  return SFX_LIBRARY[sfxId] ?? null;
}

/** Asset filename for an sfx id (or null). Preview builds `${BASE_URL}sfx/${file}`. */
export function sfxFile(sfxId: string): string | null {
  return SFX_LIBRARY[sfxId]?.file ?? null;
}
